import { render } from "./MessageList.vue?vue&type=template&id=53e1e462&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=53e1e462&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e1e462"],['__file',"src/components/h5/data/MessageList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53e1e462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53e1e462', __exports__)) {
    api.reload('53e1e462', __exports__)
  }
  
  module.hot.accept("./MessageList.vue?vue&type=template&id=53e1e462&scoped=true", () => {
    api.rerender('53e1e462', render)
  })

}


export default __exports__